(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papayo-archive"] && !Shopify.designMode) return;
  try {
    
function initPapayoArchives() {
 document.querySelectorAll('[data-archive]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const dialog = root.querySelector('dialog');
  const zoom = root.querySelector('[data-archive-zoom]');
  let opener;
  root.querySelectorAll('[data-archive-open]').forEach(link => link.addEventListener('click',event => {
   if(typeof dialog.showModal !== 'function') return;
   event.preventDefault();opener=link;
   dialog.querySelector('img').src=link.href;
   dialog.querySelector('img').alt=link.querySelector('img').alt;
   root.querySelector('[data-archive-original]').href=link.href;
   dialog.classList.remove('is-zoomed');zoom.setAttribute('aria-pressed','false');dialog.showModal();
  }));
  zoom.addEventListener('click',() => {const enlarged=dialog.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(enlarged));});
  root.querySelector('[data-archive-close]').addEventListener('click',() => dialog.close());
  dialog.addEventListener('close',() => {if(opener) opener.focus({preventScroll:true});});
 });
}
initPapayoArchives();
document.addEventListener('shopify:section:load',initPapayoArchives);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papayo-homestead"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const languageButton = event.target.closest('[data-papayo-language]');
  if (languageButton) {
    const root = languageButton.closest('.papayo-homestead');
    root.dataset.language = languageButton.dataset.papayoLanguage;
    root.querySelectorAll('[data-papayo-language]').forEach(button => button.setAttribute('aria-pressed', String(button === languageButton)));
  }
  const photo = event.target.closest('[data-papayo-photo]');
  if (photo) {
    const root = photo.closest('.papayo-homestead');
    const dialog = root.querySelector('.papayo-farm-viewer');
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      const source = photo.querySelector('img');
      const image = dialog.querySelector('img');
      image.src = photo.href;
      image.alt = source.alt;
      dialog.querySelector('p').textContent = source.alt;
      dialog.showModal();
    }
  }
  const close = event.target.closest('[data-papayo-close]');
  if (close) close.closest('dialog').close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papayo-portfolio"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (root) => {
    const sections = root.matches?.('[data-portfolio]') ? [root] : root.querySelectorAll('[data-portfolio]');
    sections.forEach(section => {
      if (section.dataset.portfolioReady) return;
      section.dataset.portfolioReady = 'true';
      const gallery = section.querySelector('.papayo-portfolio__gallery');
      const previous = section.querySelector('[data-portfolio-prev]');
      const next = section.querySelector('[data-portfolio-next]');
      if (previous && next) {
        const update = () => {previous.disabled = gallery.scrollLeft < 2;next.disabled = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;};
        const move = direction => gallery.scrollBy({left: direction * (gallery.querySelector('figure').getBoundingClientRect().width + parseFloat(getComputedStyle(gallery).gap)),behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        previous.addEventListener('click',() => move(-1));next.addEventListener('click',() => move(1));gallery.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(gallery);update();
      }
      const viewer = section.querySelector('dialog');
      const full = viewer.querySelector('[data-portfolio-full]');
      let trigger;
      section.querySelectorAll('[data-portfolio-open]').forEach(link => link.addEventListener('click',event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || !viewer.showModal) return;
        event.preventDefault();trigger = link;full.src = link.href;full.alt = link.querySelector('img').alt;viewer.showModal();
      }));
      viewer.querySelector('[data-portfolio-close]').addEventListener('click',() => viewer.close());
      viewer.addEventListener('click',event => {if(event.target === viewer){const box=viewer.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)viewer.close();}});
      viewer.addEventListener('close',() => trigger?.focus());
    });
  };
  setup(document);
  document.addEventListener('shopify:section:load',event => setup(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
